module.exports = __webpack_public_path__ + "static/img/2.c446eb8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bootcamp/cards/zombs/2.png
// module id = kn7v
// module chunks = 38